import React, { useEffect, useState, useRef } from 'react';

/**
 * Breadcrumb wrapper que fica FIXED logo abaixo da Navbar quando o usuário rola.
 * Compatível mesmo quando o html/body têm overflow-x:hidden (que quebra sticky).
 * Mede automaticamente a altura da Navbar fixa (.fixed.top-0) e ajusta.
 */
export default function StickyBreadcrumb({ children }) {
  const [navH, setNavH] = useState(0);
  const [innerH, setInnerH] = useState(0);
  const innerRef = useRef(null);

  useEffect(() => {
    const measure = () => {
      const nav = document.querySelector('.fixed.top-0');
      setNavH(nav ? nav.offsetHeight : 0);
      if (innerRef.current) setInnerH(innerRef.current.offsetHeight);
    };
    measure();
    window.addEventListener('resize', measure);
    // Re-medir após um curto delay (fontes/imagens da navbar)
    const t = setTimeout(measure, 300);
    return () => { window.removeEventListener('resize', measure); clearTimeout(t); };
  }, []);

  return (
    <>
      {/* Placeholder que reserva o espaço no fluxo */}
      <div style={{ height: navH + innerH }} aria-hidden="true" />
      {/* Barra fixa abaixo da Navbar */}
      <div
        ref={innerRef}
        className="fixed left-0 right-0 z-40 py-2 bg-slate-900/90 backdrop-blur-md border-b border-slate-800 shadow-sm"
        style={{ top: navH }}
        data-testid="sticky-breadcrumb"
      >
        <div className="container mx-auto px-4">{children}</div>
      </div>
    </>
  );
}
